import React, { useEffect, useState } from "react";
import { Field, Formik, Form } from "formik";
import * as Yup from "yup";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
// import AppInput from "components/Input/AppInput";
import { Box, FormGroup, makeStyles, Typography } from "@material-ui/core";
import AppColor from "utilities/AppColor";
import AppButton from "components/CustomButtons/AppButton";
// import { Link } from "react-router-dom";
import InputUpload from "components/Input/InputUpload";
// import AppInput from "components/Input/AppInput";
// import { YupValidations } from "utils/validate";

const VerificationForm = (props) => {
  const {
    onSubmit,
    isSubmitting,
    companyDetail = {},
    changeProgressStatus,
    display,
    // hideLeftControl,
    disabled
  } = props;

  const { t } = useTranslation();

  const [initForm, setInitForm] = useState({});

  const validationSchema = Yup.object().shape({
    certificationFile: Yup.mixed().required("validation.requiredFile"),
    professionalIndemnityInsuranceFile: Yup.mixed().required("validation.requiredFile"),
  });

  const {
    company = {}
  } = companyDetail;

  const {
    id: companyId,
    certification = '',
    certificationAws3Link = '',
    abn = '',
    professionalIndemnityInsuranceFile = '',
    professionalIndemnityInsuranceFileAws3Link = ''
  } = company;

  useEffect(() => {
    if (companyDetail && Object.keys(companyDetail).length > 0) {
      const initial = {
        certificationFile: certification,
        certificationAws3Link: certificationAws3Link,
        abn: abn || '',
        professionalIndemnityInsuranceFile: professionalIndemnityInsuranceFile,
        professionalIndemnityInsuranceFileAws3Link: professionalIndemnityInsuranceFileAws3Link
      };
      // console.log(!certification);
      // if (!certification) {
      //   setTimeout(() => {
      //     changeProgressStatus(1, false);
      //   })
      // } else {
      //   changeProgressStatus(1, true);

      // }
      validationSchema
        .isValid(initial)
        .then((valid) => {
          setTimeout(() => {
            changeProgressStatus(1, valid);
          }, 200);
        });
      setInitForm(initial);
    }
  }, [companyDetail]);

  const handleSubmitForm = (form) => {
    const params = {
      ...form,
      companyId
    };
    if (form.certificationFile && !form.certificationFile.name) {
      delete params.certificationFile;
    }
    if (form.professionalIndemnityInsuranceFile && !form.professionalIndemnityInsuranceFile.name) {
      delete params.professionalIndemnityInsuranceFile;
    }
    onSubmit(params);
  };

  const styles = makeStyles(() => ({
    title: {
      display: 'flex',
      margin: '2rem 0 1rem 0',
      '& h5': {
        color: AppColor.mainColor,
      }
    },
    control: {
      display: 'flex',
      flexWrap: 'wrap',
      flexDirection: 'row',
      justifyContent: companyId ? 'space-between' : 'flex-end',
      '& a': {
        cursor: 'pointer',
        textDecoration: 'underline',
        color: AppColor.pink
      }
    },
    textDownload: {
      cursor: 'pointer',
      '& span': {
        color: AppColor.blue,
        textDecoration: 'underline',
        marginRight: '0.5rem'
      }
    }
  }));
  const classes = styles();

  return (
    <Formik
      enableReinitialize={true}
      onSubmit={handleSubmitForm}
      initialValues={initForm}
      validationSchema={validationSchema}
    >
      {({values}) => {
        return (
          <Form className={`${!display && 'hidden'}`}>
            <Box className={classes.title}>
              <Typography variant="h5">
                {t("title.verification")}
              </Typography>
            </Box>
            <Box>
              {initForm.certificationFile ? (
                  <Box display="flex" alignItems="center">
                    <span>{t('label.certification')}</span>
                    {/* <a
                        style={{marginLeft: '1rem'}}
                        href={values.certificationAws3Link}
                        download={values.certificationFile}
                    >
                      <Box className={classes.textDownload}>
                        <i className="fas fa-download"></i>
                      </Box>
                    </a> */}
                  </Box>
              ) : (
                  <span>{t('label.certification')}</span>
              )}
              <Field
                component={InputUpload}
                name="certificationFile"
                disabled={disabled}
                urlFileBegin={values.certificationAws3Link}
                showIconUpload={true}
                showIconDownload={typeof values.certificationFile === "string" && values.certificationFile}
                renderIconDownload={() => (
                  <a style={{marginLeft: '1rem'}} href={values.certificationAws3Link} download={values.certificationFile}>
                    <Box className={classes.textDownload}>
                      <i className="fas fa-download"></i>
                    </Box>
                  </a>
                )}
              />
            </Box>
            {/* <Field
              component={AppInput}
              name="ndisPlanNumber"
              label={"label.ndisPlanNumber"}
              disabled={disabled}
            /> */}
            <Box>
              {initForm.professionalIndemnityInsuranceFile ? (
                  <Box display="flex" alignItems="center">
                    <span>{t('label.professionalIndemnityInsurance')}</span>
                  </Box>
              ) : (
                  <span>{t('label.professionalIndemnityInsurance')}</span>
              )}
              <Field
                component={InputUpload}
                name="professionalIndemnityInsuranceFile"
                disabled={disabled}
                urlFileBegin={values.professionalIndemnityInsuranceFileAws3Link}
                showIconUpload={true}
                showIconDownload={typeof values.professionalIndemnityInsuranceFile === "string" && values.professionalIndemnityInsuranceFile}
                renderIconDownload={() => (
                  <a style={{marginLeft: '1rem'}} href={values.professionalIndemnityInsuranceFileAws3Link} download={values.professionalIndemnityInsuranceFile}>
                    <Box className={classes.textDownload}>
                      <i className="fas fa-download"></i>
                    </Box>
                  </a>
                )}
              />
            </Box>
            {
              !disabled && (
                <FormGroup className={classes.control}>
                  <AppButton
                    label={`${t("button.saveAndContinue")}`}
                    rounder
                    type="submit"
                    isLoading={isSubmitting}
                    disabled={isSubmitting}
                  />
                </FormGroup>
              )
            }
          </Form>
        );
      }}
    </Formik>
  );
};

VerificationForm.propTypes = {
  onSubmit: PropTypes.func,
  isSubmitting: PropTypes.bool,
  display: PropTypes.bool,
  disabled: PropTypes.bool,
  hideLeftControl: PropTypes.bool,
  companyDetail: PropTypes.object,
  changeProgressStatus: PropTypes.func
};

export default VerificationForm;
